import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DepartmentFood } from '@app/models';
import { environment } from '@environments/environment';

const API = environment.API;

@Injectable({
  providedIn: 'root'
})
export class DepartmentFoodService {

  constructor(private http: HttpClient) { }

  get() {
		return this.http.get<DepartmentFood[]>(`${API}departmentsFood`);
	}

	getByConditions(FollowId, dataConditions?) {
		return this.http.get<DepartmentFood[]>(
			`${API}departmentsFood/reports/showroom_department?FollowId=${FollowId}${dataConditions.CountryId ? '&CountryId=' + dataConditions.CountryId : ''
			}${dataConditions.businessUnit
				? '&businessUnit=' + dataConditions.businessUnit
				: ''
			}${dataConditions.DestinationCenterId
				? '&DestinationCenterId=' + dataConditions.DestinationCenterId
				: ''
			}`
		);
	}

	create(data) {
		return this.http.post<DepartmentFood>(`${API}departmentsFood`, data);
	}

	search(conditions, FollowId) {
		const data = [...conditions, { key: 'FollowId', value: FollowId }];

		return this.http.post<any>(
			`${API}departmentsFood/hierarchyPlannerSearch`,
			data
		);
	}

	update(id, data) {
		return this.http.put<DepartmentFood>(`${API}departmentsFood/${id}`, data);
	}

	destroySingle(DepartmentId) {
		return this.http.delete<any>(`${API}departmentsFood/${DepartmentId}`);
	}


	getById(FollowId, dataConditions?) {
		return this.http.get<DepartmentFood[]>(
			`${API}departmentsFood/reports/showroom_one_department?FollowId=${FollowId}${dataConditions.CountryId ? '&CountryId=' + dataConditions.CountryId : ''
			}${dataConditions.businessUnit
				? '&businessUnit=' + dataConditions.businessUnit
				: ''
			}${dataConditions.DestinationCenterId
				? '&DestinationCenterId=' + dataConditions.DestinationCenterId
				: ''
			}${dataConditions.CategoryId
				? '&CategoryId=' + dataConditions.CategoryId
				: ''
			}`
		);
	}
}
